module.exports = __webpack_public_path__ + "static/media/partyPopper.67140c99.svg";